import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useMainContext } from "../../../Context";
import { myPayments, singlePement } from "../../../Utils/Apis";
export const useListPeyments = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({});
  const { post } = useMainContext();
  const get = async () => {
    setLoading(true);
    const { data } = await post(myPayments);
    setData(data);
    setLoading(false);
  };
  useEffect(() => {
    get();
  }, []);
  return {
    loading,
    data,
  };
};
export const useSinglePeyments = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({});
  const { post } = useMainContext();
  const { id } = useParams();
  const get = async () => {
    setLoading(true);
    const { data } = await post(singlePement, { id });
    setData(data);
    setLoading(false);
  };
  useEffect(() => {
    get();
  }, []);
  return {
    loading,
    data,
  };
};
